import '../css/index.scss';

import './common';
import initBirthDay from './cabinet/mask';

import {initCommentForm} from './front/form';
import {initGalleryFilter} from './front/filter';
import {initRatingSlider} from './front/slider';
import {initWorkLike, initWorkRoyalSlider} from './front/work';
import initContestFavorite from './front/contest-favorite';

document.addEventListener('DOMContentLoaded', () => {
  initBirthDay();
  initCommentForm();
  initRatingSlider();
  initGalleryFilter();
  initWorkLike();
  initWorkRoyalSlider();
  initContestFavorite();
});

